<template>
  <footer class="site-footer">
    <div class="footer-content">
      <div class="footer-info">
        <p>
          Cabinet de Psihologie Presecan
          <br>
          Alba Iulia
        </p>
      </div>
      <div class="footer-contact">
        <p>
          {{ address }}
        </p>
        <p>
          {{ phone }}
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
  export default {
    name: 'FooterComponent',
    props: {
      address: {
        type: String,
        default: 'Strada Vasile Goldiș nr. 2A, bl. S1, sc. B, ap. 3, interfon 03, Alba Iulia 510209'
      },
      phone: {
        type: String,
        default: '0720823740'
      }
    }
  }
</script>

<style scoped lang="scss">
  $footer-bg: #1D2A4A;
  $white: white;
  @media only screen and (min-width: 0px) {
    .site-footer {
      background-color: $footer-bg;
      color: $white;
      padding: 25px 20px;
      width: 100%;
      margin-top: 0;
      box-sizing: border-box;

      .footer-content {
        max-width: 1200px;
        margin: 0 auto;
        display: flex !important;
        flex-direction: column;
        align-items: center !important;
        text-align: center !important;

        @media (min-width: 768px) {
          flex-direction: row;
          justify-content: space-between;
          text-align: center !important;
        }
      }

      p {
        margin: 0;
        font-size: 18px;
        line-height: 1.5;
        font-weight: 300;
      }

      .footer-info, .footer-contact {
        margin: 10px 0;
        text-align: center !important;

        @media (min-width: 768px) {
          margin: 0;
        }
      }
    }
  }
</style>